import { NgModule, ErrorHandler, Injectable } from "@angular/core";
import * as Sentry from "@sentry/browser";
import { environment } from "@environments/environment";

Sentry.init({
  dsn: environment.sentry,
  environment: environment.name,
  release: environment.version,
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    Sentry.captureException(error.originalError || error);
  }
}

@NgModule({
  providers: [{ provide: ErrorHandler, useClass: SentryErrorHandler }],
})
export class ErrorModule {}
